<template>
    <div class="flex flex-col h-full w-full gap-2 px-2">
        <div class="flex flex-col h-0 grow w-full">
            <DxDataGrid
                width="100%"
                height="100%"
                ref="gridCardRef"
                column-resizing-mode="widget"
                :autoExpandAll="false"
                :data-source="dataSource"
                :columns="gridColumns"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-borders="true"
                :remote-operations="true"
                :key-expr="keyExpr"
                :filter-row="filterRow"
                :filter-panel="{ visible: filterPanelShow }"
                :focused-row-enabled="true"
                :EnableGroupPanel="true"
                @context-menu-preparing="onContextMenu"
                @option-changed="onOptionChangedFunc"
                @focusedRowChanging="onFocusedRowChanging"
                @selectionChanged="selectionChanged"
                @row-expanding="onRowExpanding"
                @editor-preparing="editorPreparing"
                @exporting="onExporting"
            >
                <dx-toolbar :visible="toolbarShow">
                    <slot name="toolbarItems" />
                    <dx-item :visible="groupPanelVisible" location="before" name="groupPanel" />

                    <dx-item
                        :visible="props.toolbarMeta?.refreshButton?.visible !== false"
                        widget="dxButton"
                        location="after"
                        name="refresh"
                    >
                        <dx-button hint="Обновить" icon="refresh" @click="refresh()" />
                    </dx-item>

                    <dx-item
                        :visible="props.toolbarMeta?.editButton?.visible !== false"
                        location="after"
                        widget="dxButton"
                        name="edit"
                    >
                        <dx-button hint="Редактировать" icon="edit" @click="onEditClick()" />
                    </dx-item>

                    <dx-item
                        :visible="props.toolbarMeta?.addButton?.visible !== false"
                        location="after"
                        widget="dxButton"
                        name="add"
                    >
                        <dx-button hint="Добавить" icon="add" @click="onAddClick()" />
                    </dx-item>

                    <dx-item
                        :visible="props.toolbarMeta?.deleteButton?.visible !== false"
                        location="after"
                        widget="dxButton"
                        name="delete"
                    >
                        <dx-button
                            hint="Удалить запись"
                            icon="trash"
                            @click="onDeleteClick()"
                            :disabled="isDeleteButtonDisabled"
                        />
                    </dx-item>

                    <dx-item
                        :visible="props.toolbarMeta?.copyButton?.visible !== false"
                        location="after"
                        widget="dxButton"
                        name="copy"
                    >
                        <dx-button hint="Копировать" icon="copy" @click="onCopyClick()" />
                    </dx-item>

                    <dx-item
                        :visible="props.toolbarMeta?.saveButton?.visible !== false"
                        location="after"
                        widget="dxButton"
                        name="save"
                    >
                        <dx-button
                            hint="Сохранить изменения"
                            icon="save"
                            @click="() => gridInstance.value.saveEditData()"
                        />
                    </dx-item>

                    <dx-item name="exportButton" location="after" locate-in-menu="auto" />

                    <dx-item
                        :visible="props.toolbarMeta?.menuButton?.visible !== false"
                        location="after"
                        widget="dxMenu"
                        name="menu"
                        class="settings"
                        locateInMenu="auto"
                    >
                        <dx-drop-down-button
                            icon="preferences"
                            displayExpr="text"
                            hint="Добавить пользователя"
                            styling-mode="text"
                            :items="[
                                {
                                    text: !groupPanelVisible
                                        ? 'Показать область группировки '
                                        : 'Скрыть область группировки',
                                    onClick: onGroupAreaClick,
                                },
                                {
                                    name: 'defaultSettings',
                                    text: 'Заводские настройки',
                                    onClick: () => {},
                                },
                                {
                                    name: 'userSettings',
                                    text: 'Настройки пользователя',
                                    onClick: async () => {
                                        gridInstance.value.refreshMeta();
                                    },
                                },
                            ]"
                            :dropDownOptions="{ width: 400 }"
                        />
                    </dx-item>

                    <dx-item
                        :visible="props.toolbarMeta?.columnChooserButton?.visible !== false"
                        location="after"
                        name="columnChooserButton"
                    />

                    <dx-item
                        :visible="props.toolbarMeta?.searchButton?.visible !== false"
                        location="after"
                        name="searchPanel"
                    />
                </dx-toolbar>
                <dx-editing
                    :allow-adding="false"
                    :allow-deleting="false"
                    :allow-updating="false"
                    :use-icons="true"
                    mode="batch"
                />
                <DxSearchPanel :visible="true" placeholder="Поиск..." />
                <DxSelection :mode="selectionMode" :allowSelectAll="false" />
                <DxGroupPanel v-if="isGrouping" :visible="groupPanelVisible" />
                <DxGrouping v-if="isGrouping" :auto-expand-all="false" :contextMenuEnabled="true" />
                <DxFilterBuilder :group-operations="['and', 'notAnd']" />
                <DxPaging :page-size="100" :enabled="true" />
                <DxSorting mode="single" />
                <DxScrolling mode="virtual" />
                <DxExport :enabled="true" :formats="['pdf', 'excel']" :allow-export-selected-data="true" />
                <DxRemoteOperations :group-paging="true" />
                <template v-for="template in cellTemplates" #[template.name]="{ data: ctx }" :key="template.name">
                    <component :is="template.component" :data="ctx" />
                </template>
                <DxColumnChooser :width="300" :height="500" :enabled="true" mode="select">
                    <DxColumnChooserSearch :enabled="true" />
                    <DxColumnChooserSelection />
                </DxColumnChooser>
                <DxSummary>
                    <DxGroupItem column="Id" summary-type="count" />
                </DxSummary>
            </DxDataGrid>
        </div>
        <grid-footer ref="childRef" :totalCount="totalCount" :show-selected="totalCountSelectedShow"></grid-footer>
    </div>
</template>

<script>
export default {
    name: 'grid-card',
};
</script>

<script setup>
import store from '@/store';
import {
    DxDataGrid,
    DxColumnChooser,
    DxSummary,
    DxGroupItem,
    DxExport,
    DxGrouping,
    DxColumnChooserSearch,
    DxColumnChooserSelection,
    DxGroupPanel,
    DxPaging,
    DxRemoteOperations,
    DxSearchPanel,
    DxSorting,
    DxFilterBuilder,
    DxSelection,
    DxScrolling,
    DxToolbar,
    DxItem,
    DxEditing,
} from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DataSource from 'devextreme/data/data_source';
import { ref, defineProps, defineEmits, onMounted, onDeactivated, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import onExporting from '@/utils/export-to-excel.js';
import { gridCardStore } from '@/components/grid-card-component/grid-card-store';
import GridFooter from '@/components/grid-footer.vue';

const props = defineProps({
    columnsMeta: {
        type: Array,
        default: () => [],
    },
    isGrouping: {
        type: Boolean,
        default: true,
    },
    totalCountSelectedShow: {
        type: Boolean,
        default: () => true,
    },
    totalCountProps: {
        type: Number,
        default: () => 0,
    },
    keyExpr: {
        type: String,
        default: () => 'id',
    },
    toolbarShow: {
        type: Boolean,
        default: true,
    },
    toolbarMeta: {
        type: Object,
        default: () => {},
    },
    contextMenuMeta: {
        type: Array,
        default: () => [],
    },
    emptyCardName: {
        type: String,
        default: () => '',
    },
    cardName: {
        type: String,
        default: () => '',
    },
    customContextMenu: {
        type: Array,
        default: () => [],
    },
    viewName: {
        type: String,
        default: '',
    },
    api: {
        type: String,
        default: '',
    },
    selectionMode: {
        type: String,
        default: () => 'multiple',
    },
    storeArgs: {
        type: Object,
        default: () => {},
    },
    initMetaData: {
        type: Boolean,
        default: true,
    },
    filterPanelShow: {
        type: Boolean,
        default: true,
    },
    filterRow: {
        type: Object,
        default: () => {
            return { visible: true };
        },
    },
});

const gridCardRef = ref();
const gridColumns = ref([]);
// const selectedRows = ref(0);
const cellTemplates = [];
const editCellTemplates = [];
const gridInstance = ref(null);
let dataSource = null; //new DataSource(props.data);
const router = useRouter();
const childRef = ref(null);
const totalCount = ref(0);
const groupPanelVisible = ref(false);
const rowsPreparedToDelete = ref([]);
const isDeleteButtonDisabled = ref(true);

const emit = defineEmits([
    'expandParentItem',
    'getHiddenColumns',
    'onFocusedRowChanging',
    'selectionChanged',
    'onRowExpanding',
]);

const filterOperations = {
    string: ['contains', 'notcontains', 'startswith', 'endswith', '=', '<>'],
    numeric: ['=', '<>', '<', '>', '<=', '>='],
    number: ['=', '<>', '<', '>', '<=', '>='],
    date: ['=', 'between'],
};

const refresh = () => gridInstance.value.refresh();

const onEditClick = () => {
    const id = gridInstance.value.option('focusedRowKey');
    id &&
        router.push({
            name: props.cardName,
            params: { id },
        });
};

const onAddClick = () => {
    router.push({
        name: props.emptyCardName,
    });
};

const onDeleteClick = () => {
    const selectedRows = gridInstance.value.getSelectedRowKeys();
    selectedRows.forEach(key => {
        const index = gridInstance.value.getRowIndexByKey(key);
        if (rowsPreparedToDelete.value.includes(key)) {
            gridInstance.value.undeleteRow(index);
            rowsPreparedToDelete.value = rowsPreparedToDelete.value.filter(value => value !== key);
        } else {
            gridInstance.value.deleteRow(index);
            rowsPreparedToDelete.value.push(key);
        }
    });
    gridInstance.value.clearSelection();
};

const onCopyClick = () => {};

const onGroupAreaClick = () => {
    groupPanelVisible.value = !groupPanelVisible.value;
};

const onOptionChangedFunc = e => {
    if (e.fullName.includes('visible')) {
        emit(
            'getHiddenColumns',
            e.component.option('columns').filter(el => !el.visible)
        );
    }
};
// const searchByText = async (text) => {
//   gridCardRef.value.searchByText(text)
// }
const editorPreparing = async e => {
    e.updateValueTimeout = 2000;
    if (e.parentType === 'searchPanel') {
        e.editorOptions.onValueChanged = function (arg) {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => {
                if (arg.value.length == 0 || arg.value.length > 2) {
                    e.component.searchByText(arg.value);
                }
            }, 2000);
        };
    }
};

const onRowExpanding = e => {
    emit('onRowExpanding', e);
};

const processColumns = (columns, parentId) => {
    return columns
        .filter(column => column.parent_id === parentId)
        .sort((a, b) => a.index - b.index)
        .map(column => {
            const childColumns = processColumns(columns, column.id);
            if (childColumns.length > 0) {
                const obj = {
                    caption: column.text,
                    columns: childColumns,
                };
                if (column.cssClass) obj.cssClass = column.cssClass;
                return obj;
            } else {
                const obj = {
                    caption: column.text,
                    visible: column.visible !== false,
                };
                obj.dataField = column.field ? column.field : '';
                obj.dataType = column.data_type ? column.data_type : '';
                obj.filterOperations = column.data_type ? filterOperations[column.data_type] : '';
                obj.width = column.width ? column.width : 100;
                obj.groupIndex = column.group_index;
                if (column.format) obj.format = column.format;
                if (column.cellTemplate) {
                    const name = `cellTemplate-${column.field}`;
                    const template = { name, component: column.cellTemplate };
                    cellTemplates.push(template);
                    obj.cellTemplate = name;
                }
                if (column.editCellTemplate) {
                    const name = `editCellTemplate-${column.field}`;
                    const template = { name, component: column.editCellTemplate };
                    editCellTemplates.push(template);
                    obj.editCellTemplate = name;
                }
                if (column.editorOptions) obj.editorOptions = column.editorOptions;
                if (column.sortingMethod) obj.sortingMethod = column.sortingMethod;
                if (column.alignment) obj.alignment = column.alignment;
                if (column.fixed) obj.fixed = column.fixed;
                if (column.cssClass) obj.cssClass = column.cssClass;
                return obj;
            }
        });
};

const onFocusedRowChanging = e => {
    emit('onFocusedRowChanging', e);
    if (e.prevRowIndex !== e.newRowIndex) {
        if (e.rowElement[0].className.includes('group-row')) {
            e.cancel = true;
            setTimeout(() => {
                e.component.option('focusedRowIndex', -1);
            });
        }
    }
};

const selectionChanged = event => {
    emit('selectionChanged', event);
    childRef.value.selectRows(event.selectedRowKeys.length, totalCount);
    event.selectedRowKeys.length > 0 ? (isDeleteButtonDisabled.value = false) : (isDeleteButtonDisabled.value = true);
};

const onContextMenu = event => {
    if (event.target !== 'content') return;
    let items = [
        {
            name: 'gotoCard',
            text: 'Посмотреть карточку',
            visible: true,
            onItemClick() {
                const id = event.row.data[props.keyExpr];
                console.log(id, router);
                router.push({
                    name: props.cardName,
                    params: { id },
                });
            },
        },
    ];
    event.items = items;
    if (event.row && props.customContextMenu) {
        const context = props.customContextMenu.map(item => {
            return { ...item, rowData: event.row };
        });
        event.items.push(...context);
    }
    event.items = recursivelyChangeProperty(event.items, props.contextMenuMeta, 'name');
};

const recursivelyChangeProperty = (toolbar, meta, propertyName) => {
    toolbar.forEach(obj1 => {
        meta.forEach(obj2 => {
            if (obj1.name === obj2.name) {
                obj1.visible = obj2.visible;
            }
        });
        if (Array.isArray(obj1.children)) {
            recursivelyChangeProperty(obj1.children, meta, propertyName);
        }
    });
    return toolbar;
};

onDeactivated(() => {
    store.dispatch('cleanGridMetaData');
});

const loadMeta = async () => {
    if (props.api) {
        await store.dispatch(
            'loadGridMetaData',
            {
                name: props.viewName,
                api: props.api.substring(0,props.api.indexOf('/data/get'))//props.api.split('/')[0]
            });
    }
};

const initialMetaData = async () => {
    if (dataSource === null) {
        await loadMeta();
        dataSource = new DataSource(gridCardStore(props.storeArgs, props.storeArgs.api));
        dataSource.on('changed', e => {
            totalCount.value = dataSource.totalCount();
        });
        //dataSource.load();
        refreshMeta();
    }
};

onMounted(async () => {
    gridInstance.value = gridCardRef.value?.instance;
    if (store.state.registryGrid.regGrid) gridColumns.value = processColumns(store.state.registryGrid.regGrid, null);
});

onBeforeMount(async () => {
    if (props.initMetaData) {
        await initialMetaData();
    }
});

const refreshMeta = () => {
    gridColumns.value = processColumns(store.state.registryGrid.regGrid, null);
};

defineExpose({
    gridInstance,
    refreshMeta,
    initialMetaData,
});
</script>

<style lang="scss" scoped>
:deep(.dx-menu-item-content) {
    display: flex;
    align-items: center;
}

:deep(.dx-row-removed > td) {
    background-color: white;
    text-decoration: line-through;
}
</style>
